import { PlusOutlined } from "@ant-design/icons";
import { Button, Drawer, Layout, Space } from "antd";
import React, { useEffect, useState } from "react";
import "./style.css";
import { isFunction } from "lodash";

const BigDrawer = ({ children, btnTitle, title, className, openFlag = false, setOpenFlag }) => {
  const { Content } = Layout;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open != openFlag) {
      setOpen(openFlag);
    }
  }, [openFlag]);

  const showDrawer = () => {
    setOpen(true);
    isFunction(setOpenFlag) && setOpenFlag(true);
  };
  const onClose = () => {
    setOpen(false);
    isFunction(setOpenFlag) && setOpenFlag(true);
  };
  return (
    <>
      <Button
        className={className ? className : "flex justify-center items-center"}
        type='primary'
        id='btn-drawer'
        onClick={showDrawer}
        icon={<PlusOutlined />}
      >
        {btnTitle}
      </Button>
      <Drawer
        title={`Create a ${title}`}
        width={"50%"}
        onClose={onClose}
        open={open}
        destroyOnClose
        bodyStyle={{
          paddingBottom: 80,
        }}
        extra={
          <Space>
            <Button id='btn-drawer' type='danger' onClick={onClose}>
              Cancel
            </Button>
          </Space>
        }
      >
        <Content>{children}</Content>
      </Drawer>
    </>
  );
};
export default BigDrawer;
